import React, { Component } from 'react'
import FixedView from '../FixedView'
import StagesManager from '../StagesManager'
import IntractionActionsList from '../IntractionActionsList'
import { checkPermission, translate } from '../../utils/useful'
import GroupedBy from '../inputs/GroupedBy'
import importedIcons from '../inputs/icons'
import SortedBy from '../inputs/SortedBy'

export default class DataMenu extends Component {


  functionsHandler = (type, name, data) => {
    this.props.setCurrentHead({})
    this.props.functionsHandler(type, name, data)
    this.fiexView.hideView()
  }

  changePageSubMenu = (title) => {
    this.stageManager.changeStage(title)
  }

  componentDidUpdate() {

  }
  render() {
    return (
      <>
        <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.setting = el} onClick={() => { this.fiexView.showView() }}>
          <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('data.Data')}</p>
        </button>

        <FixedView width={this.props.width} zIndex={10} ref={el => this.fiexView = el} nodeRef={this.setting} xOffset={this.props.language == 'fa' ? 195 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
          <div className='bg-white br-10 p-1 shadow-3 sc-gray2'>
            <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
              <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'ّfile'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                <div className=''>


                  <div onClick={() => this.functionsHandler('collectionView', 'openSearch')} className='w-100  mb-1 cursor-pointer' style={{ borderBottom: "0px solid #eee" }}>
                    <input disabled={true} placeholder={translate('Search')} className='py-1 px-2 br-5 w-100 cursor-pointer' style={{ backgroundColor: '#F2F2F7', border: '1px solid #F2F2F7' }} />
                  </div>

                  {checkPermission(this.props.permissions, `frames.${this.props.frame?._id}.addNewRecord`) && (
                    <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'addClicked')} language={this.props.language} data={{ title: "{{lang}}New Record", shortcut: 'Ctrl+N', icon: importedIcons.record }} />
                  )}

                  <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openFilterView')} data={{ title: "{{lang}}Advanced Search", icon: importedIcons.advanceSearch, check3: this.props.hasFilter }} />

                  <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openPrintView')} data={{ title: "{{lang}}Print lable", icon: importedIcons.printLable, check3: this.props.hasFilter }} />
                  {/* <IntractionActionsList  data={{ title: "{{lang}}New Record", shortcut: 'Ctrl+O', icon: "/assets/icons/note/file/open.svg" }} /> */}
                  {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}data.Search", icon: "/assets/icons/note/file/copy.svg" }} /> */}
                </div>
                <div className='pt-1 mt-1' style={{ borderTop: "1px solid #eee" }}>
                  {checkPermission(this.props.permissions, `frames.${this.props.frame?._id}.customFields`, 'add') && (
                    <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openAddCustomField')} data={{ title: "{{lang}}Add Custom Field", icon: importedIcons.addCustomField }} />
                  )}
                  {checkPermission(this.props.permissions, `frames.${this.props.frame?._id}.customizeFields`) && (
                    <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openCustomizeFields')} data={{ title: "{{lang}}Customize Fields", icon: importedIcons.costumizeField }} />
                  )}


                  {checkPermission(this.props.permissions, `frames.${this.props.frame?._id}.customizeFields`) && (
                    <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openCustomizeCard')} data={{ title: "{{lang}}Customize Cards", icon: importedIcons.costumizeField }} />
                  )}


                </div>

                <div className='pt-1 mt-1' style={{ borderTop: "1px solid #eee" }}>
                  {checkPermission(this.props.permissions, `collection.${this.props.frame?._id}.saveFilter`) && (
                    <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openFilterView')} data={{ title: "{{lang}}Saved Filters", icon: importedIcons.savedFilters, }} />
                  )}
                  <IntractionActionsList onClick={() => this.changePageSubMenu("groupby")} data={{ title: "{{lang}}Group By", icon: importedIcons.groupBy, check3: this.props.hasGroupBy }} />
                  <IntractionActionsList onClick={() => this.changePageSubMenu("sortby")} data={{ title: "{{lang}}Sort By", icon: importedIcons.sortBy, check3: this.props.hasSortedBy }} />
                  {/* <IntractionActionsList onClick={() => this.functionsHandler('collectionView', 'openSortBy')} data={{ title: "{{lang}}Sort By", icon: importedIcons.sortBy, check3: this.props.hasSortedBy }} /> */}


                  {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}data.Filter", sub: true, icon: "/assets/icons/note/file/share.svg" }} /> */}
                  {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}data.Sortby", sub: true, icon: "/assets/icons/note/file/email.svg" }} />
                  <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}data.Groupby", sub: true, icon: "/assets/icons/note/file/download.svg" }} />
                  <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}data.Saved Filters", sub: true, icon: "/assets/icons/note/file/download.svg" }} /> */}
                  {/* <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}data.Customize Fields", sub: true, icon: "/assets/icons/note/file/download.svg" }} /> */}
                </div>
              </div>



              <div width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={"groupby"} className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}    >
                <div className="">
                  <div className="pb-2">
                    <button className="flexc w-100 hover-gray p-2 br-10" onClick={() => this.stageManager.lastStage()}  >
                      <img width={18} src={importedIcons.arrowLeft} className="rtl-button" />
                      <p className="font-size-13 weight-500 mld-3 main-c3 text-start">  {translate("Group By")}   </p>
                    </button>
                  </div>
                  <div className="pt-2" style={{ borderTop: "1px solid #eee" }}    >

                    <GroupedBy setData={this.setData} headers={this.props.headers} width={this.props.width} colors={this.props.colors} functionsHandler={this.props.functionsHandler} view={this.props.view} />

                  </div>
                </div>
              </div>

              <div width={this.props.width} isLoading={this.props.isLoading} stage={2} stageName={"sortby"} className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}    >
                <div className="">
                  <div className="pb-2">
                    <button className="flexc w-100 hover-gray p-2 br-10" onClick={() => this.stageManager.lastStage()}  >
                      <img width={18} src={importedIcons.arrowLeft} className="rtl-button" />
                      <p className="font-size-13 weight-500 mld-3 main-c3 text-start">  {translate("Sort By")}   </p>
                    </button>
                  </div>
                  <div className="pt-2" style={{ borderTop: "1px solid #eee" }}    >

                    <SortedBy setData={this.setData} headers={this.props.headers} width={this.props.width} colors={this.props.colors} functionsHandler={this.props.functionsHandler} view={this.props.view} />

                  </div>
                </div>
              </div>


            </StagesManager>
          </div>
        </FixedView>
      </>
    )
  }
}
